import React from 'react'
import { withRouter } from 'react-router-dom';
import FooterSingle from './_FooterSingle'

import axios from 'axios'
import { API_URL, TOKEN } from '../etc/constants'

import * as kit from '../kit'
import {Flex} from './layout'
import Superface from '../Superface'
import GalleryLarge from './_GalleryLarge'
import GallerySmall from './_GallerySmall'
import Masonry from 'masonry-layout'

export default class Single extends React.Component{

    constructor(props){
        super(props)
        this.handleScroll = this.handleScroll.bind(this)
        this.handleResize = this.handleResize.bind(this)
        this.refresh = this.refresh.bind(this)
        this.state = {
            mounted : false,
            leaving : false
        }
    }

    componentWillReceiveProps(new_props){
        
        if( Superface.ready && this._single === undefined ){
            Superface.setLoading(true)
            this.setState({...this.state, mounted : false})
            this._single = Superface.getSingleBySlug( this.props.match.params.slug, this._type )
            this.loadSingle()
        }

        if( new_props.match.params.slug !== this.props.match.params.slug ){
            // on change de projet 
            Superface.setLoading(true)
            this.setState({...this.state, mounted : false})
            this._single = Superface.getSingleBySlug( new_props.match.params.slug, this._type )
            this.loadSingle()
        }
    }
    
    componentWillMount(){
        
        if( Superface.ready && this._single === undefined ){
            this._single  = Superface.getSingleBySlug( this.props.match.params.slug, this._type )
            document.title = Superface.field(this._single, 'name') + ' - Superface'
            this.loadSingle()
        }
        window.addEventListener( 'resize', this.handleResize )
    }

    loadSingle(){
        
        let ids = []
        let images_loaded = 0
        
        ids.push( this._single.featured_image._id )
        
        this._single.medias.forEach( (media) => {
            if( media.field.name === 'image' && media.value !== null ){
                if( media.value.image !== null ){
                    if( !media.value.image.video ) {
                      ids.push(media.value.image._id)
                    }
                }
            }else if( media.field.type === 'gallery' ){
                if( media.value ){
                    // console.log(media.value)
                    media.value.forEach( img => {
                        console.log(img.meta.asset)
                      ids.push(img.meta.asset)
                    })
                }
            }
        })
        
        ids.forEach( (id) => {
          console.log(id)
          axios.request({
            method: 'post',
            url: `${API_URL}/cockpit/image?token=${TOKEN}`,
            data: {
              src: id, 
              m: 'thumbnail',
              w: 680, 
              q:50
            }
          }).then(response => {
            console.log(response)
            let img = new Image()
            img.onload = () => {
              images_loaded += 1
              if (images_loaded === Math.round(ids.length / 2)){
                Superface.setloadProgress('inc')
              }
              if (images_loaded >= ids.length) {
                this.initPage()
              }
            }
            img.src = response.data
          })
      })
    }

    initPage(){
      
      document.querySelector('#page-single').scrollTo(0,0)
      // setTimeout(() => {
      if( !Superface.IS_MOBILE ) this.initMasonry()
      if( !Superface.IS_MOBILE_OR_TABLET ) this.initParallax()
      if( !Superface.IS_MOBILE_OR_TABLET ) this.handleScroll()
      if(!Superface.IS_MOBILE_OR_TABLET) 
      this.mediasContainer.addEventListener( 'scroll', this.handleScroll )   
      this.setState({
        ...this.state, mounted : true, leaving : false
      })
      Superface.setLoading(false)
      // }, 3000)
      console.log('initPage')
    }

    initMasonry(){
      this.masonry = {}
      const grid = document.getElementById('scrollable-body')
      let col_width = ''
      let size = ['sm','md','lg']
      size.forEach( s => {
        if ( document.querySelectorAll('.image_' + s).length > 0){
          col_width = '.image_' + s
        }
      })
      
      this.masonry = new Masonry(grid, { columnWidth: col_width, itemSelector : '.brick' })
        
    }

    initParallax(){
        this.scrollData = []
        // const container = this.mediasContainer
        const scrollableBody = document.getElementById('scrollable-body')
        // const progress = container.scrollTop / scrollableBody.offsetHeight
        document.querySelectorAll('.brick.scrollable').forEach(
            (el,i) => {
                let q = i % 3 === 0 ? 0.85 : 0.65
                if( i % 2 === 0 ) q *= 0.4
                this.scrollData.push( {
                   topPos: parseInt(el.style.top) + scrollableBody.offsetTop,
                    height : el.clientHeight,
                    q : q
                })
            }
        )
        // this.containerHeight = this.mediasContainer.offsetHeight
    }

    setBrickPos(i, progress, el){
       const q = this.scrollData[i].q
       // const py = this.scrollData[i].topPos
       const tr = el.childNodes[0].style.transform.split(' ')
       let currentY = parseFloat(tr[1].replace('translateY(', '').replace('%)',''))
       const targetY = q * progress * 200
       const nextY = currentY + (targetY - currentY) * 0.13
      //  if (i === 3) console.log(targetY)
       const transform = 'translateX(' + 0 + '%)' + ' translateY(' + nextY + 'px)'
        el.childNodes[0].style.transform = transform

    }

    componentWillUnmount(){
        window.clearTimeout( this.timeoutMount )
        window.clearTimeout( this.timeoutScroll )
        cancelAnimationFrame( this.rafID )
        if(this.timeoutLoad) clearTimeout( this.timeoutLoad )
        if(this.timeoutChange) clearTimeout( this.timeoutChange )
        this.mediasContainer.removeEventListener( 'scroll', this.handleScroll )
        window.removeEventListener( 'resize', this.handleResize )
    }

    handleResize(){
        this.setState({...this.state})
    }

    componentDidMount(){
        Superface.setLoading(true)
    }

    handleScroll(e){
        
        if( Superface.IS_MOBILE_OR_TABLET ) return
        if( this.timeoutScroll ) clearTimeout( this.timeoutScroll )

        if( !this.isScrolling ){
            this.rafID = requestAnimationFrame( this.refresh )
        }
        this.timeoutScroll = setTimeout( () => {
            this.isScrolling = false
            cancelAnimationFrame( this.rafID )
        }, 500)

    }


    refresh(){
        
        this.isScrolling = true
        const container = this.mediasContainer
      //   const scrollableBody = document.getElementById('scrollable-body')
        document.querySelectorAll('.brick.scrollable').forEach(
            (el,i) => {
                var elemTop = this.scrollData[i].topPos;
                var elemHeight = el.offsetHeight;
                     
               const scrollOffset = container.scrollTop 
               const relativeOffset = elemTop - scrollOffset
               const p = (relativeOffset + elemHeight) / (window.innerHeight + elemHeight)
               // if(i===3){
               //     el.style.border = '1px solid red'
               //    console.log({ p })
               // }
               if(p >= 0 && p <= 1){
                   this.setBrickPos(i, p, el )
               }
               
            }
        )
        this.rafID = requestAnimationFrame( this.refresh )
    }


    renderFeaturedImage(single){
        if( !Superface.IS_MOBILE_OR_TABLET ){
            return(
                <div className='single-featured-container' style={{width:'50%', overflow: 'hidden', position:'relative'}}>
                    <img src={Superface.assetUrl(single.featured_image.path)} alt={ Superface.field( this._single, 'name' ) } />
                </div>
            )
        }
    }

    renderSubTitle(single){
        if( this._type === 'projet' ){
            return(
                <div className="single-type" style={{textAlign:'center', marginBottom:'1rem'}}>
                    { Superface.field(single.activity_area, 'display') }
                </div>
            )
        }
    }

    render(){
        let single = this._single
        const key_uri = ( this._type === 'kind' ? 'matieres' : 'projets' )
        const style = {
            position : 'absolute', 
            top: 0, left:0, right:0, bottom:0, 
            minHeight:'100vh', 
            zIndex:500, 
            backgroundColor:'white', 
            overflowY: 'scroll', overflowX : 'hidden'
        }
        
        if( !single ) return <div id="page-single" ref={el => {this.mediasContainer = el }}></div>
        
        let text = Superface.field( single, 'body')
        
        return(
            <div 
                id="page-single" 
                ref={el => {this.mediasContainer = el }} 
                style={style} 
                className={ 
                    ( this.state.mounted ? 'mounted ' : ' ' ) + 
                    ( ( this.state.leaving || this.props.singleLeaving ) ? 'leaving ' : ' ' ) +
                    ( Superface.IS_MOBILE ? 'mobile ' : ' ' )
                }
                >
                
                <div>
                    <div style={{display:'flex'}}>
                        
                        {this.renderFeaturedImage(single)}

                        <div style={{width:'50%', padding:'4rem', flex:1}}>

                            <Flex direction="column" justify="center" align="center" style={{width:'100%', paddingTop: ( Superface.IS_MOBILE_OR_TABLET ? '4rem' : '10vh')}}>
                                
                                {this.renderSubTitle(single)}
                                <h1 className='single-title' style={{textTransform:'capitalize', fontSize:'3rem', textAlign:'center', paddingBottom:'2rem'}}>
                                    { Superface.field(single, 'name') }
                                </h1>
                                
                                <div className='single-body' style={{maxWidth : 450 }} dangerouslySetInnerHTML={ this.createMarkup(text) } ></div>

                            </Flex>
                            
                        </div>
                        
                    </div>


                    <div id="scrollable-body" className='single-medias'>{this.renderMedias()}</div>


                    <div className="single-footer" style={{display:'flex', width:'calc( 100% - 4rem)', justifyContent:'space-between', padding:'4rem 2rem', marginTop:'10vh'}}>
                        
                        <div className="single-bottom-nav-item previous">
                            {this.renderPreviousItemNav()}
                        </div>

                        <div>
                            <div onClick={ () => { 
                                Superface.singleLeaving(true)
                                setTimeout(() => {
                                    Superface.goTo( Superface.uri(key_uri)) 
                                    Superface.singleLeaving(false)
                                },600)
                                
                                }} className="cross">
                                <img src={require('../images/cross.svg')} alt='cross' />
                            </div>
                        </div>

                        <div className="single-bottom-nav-item next">
                            {this.renderNextItemNav()}
                        </div>

                    </div>

                </div>
                
                <FooterSingle />

                
            </div>
        )
    }


    renderNextItemNav(){
        let nextItem = Superface.getNextSingle(this._single, this._type)
        let fontSize = ( Superface.IS_MOBILE_OR_TABLET ? '1.2rem' : '2rem' )
        if( window.innerWidth < 1440 ) fontSize = '1.5rem'
        const key_uri = ( this._type === 'kind' ? 'matieres' : 'projets' )
        if( nextItem ){
            return(
                <Flex
                    align="center"
                    justify={ Superface.IS_MOBILE ? "flex-end" : "center"} 
                    onMouseDown={() => { 
                        this.goToSingle(nextItem)
                    }}
                    >
                    <div>
                        <div className="next-text">{Superface.translate('Projet suivant : ')}</div>
                        <div style={{fontSize:fontSize,textTransform:'capitalize'}} >
                            { Superface.field(nextItem, 'name') }
                        </div>
                    </div>
                    
                    <div className="arrow">
                        <img src={require('../images/arrow-right.svg')} alt='arrow' />
                    </div>
                </Flex>
            )
        }
        return
    }
    
    renderPreviousItemNav(){
        let previousItem = Superface.getPreviousSingle(this._single, this._type)
        let fontSize = ( Superface.IS_MOBILE_OR_TABLET ? '1.2rem' : '2rem' )
        
        if( window.innerWidth < 1440 ) fontSize = '1.5rem'
        if( previousItem ){
            return(
                <Flex
                    align="center"
                    justify={ Superface.IS_MOBILE ? "flex-start" : "center"} 
                    onMouseDown={() => {
                        this.goToSingle(previousItem)
                    }}
                    >
                    <div className="arrow">
                        <img src={require('../images/arrow-left.svg')} alt='arrow' />
                    </div>
                    
                    <div>
                        <div className="previous-text">{Superface.translate('Projet précédent :')}</div>
                        <div style={{fontSize:fontSize, textTransform:'capitalize'}} >
                            { Superface.field(previousItem, 'name') }
                        </div>
                    </div>
                </Flex>
            )
        }
        return
    }

    goToSingle(single){
        const key_uri = ( this._type === 'kind' ? 'matieres' : 'projets' )
        this.setState({...this.state, leaving : true, mounted : false})
        this.timeoutChange = setTimeout( () => {
            Superface.goTo(Superface.uri(key_uri) + '/' + single.slug)
        }, 500)
    }

   //  renderCols(medias, i){
   //     const C = ['yellow', 'red', 'blue', 'gold', 'green', 'black', '#dddddd', 'tomato', 'yellow', 'red', 'blue', 'gold', 'green', 'black', '#dddddd', 'tomato', 'yellow', 'red', 'blue', 'gold', 'green', 'black', '#dddddd', 'tomato', 'yellow', 'red', 'blue', 'gold', 'green', 'black', '#dddddd', 'tomato']
   //      return (
   //          <div key={"col-" + i} className="single-cols">
   //              { medias.map( (media, i) => {

   //                  const style = {
   //                      display: 'block', border : `1px solid ${C[i]}`
   //                  }
   //                  console.log(style)
   //                  switch( media.field.name){
                            
   //                      case 'gallery_xs':
   //                          if( media.value === null ) return
   //                          return( 
   //                              <div style={style} className={"brick image_sm gallery-small"} key={"medias-" + i}>
   //                                  <GallerySmall i={i} slides={media.value} name="single" /> 
   //                              </div>
   //                          )
        
   //                      default:
   //                          if( media.value === null ) return
   //                          if( media.value.size === undefined ) return
   //                          if( media.value.image === null ) return

   //                          if( media.value.image.video ){

   //                              if( !Superface.IS_MOBILE_OR_TABLET ){
   //                                  return(
   //                                      <div style={style} className={"brick image_" + media.value.size.toLowerCase()} key={i}>
   //                                          <video muted src={Superface.assetUrl(media.value.image.path)} alt={Superface.field(this._single, 'name')} autoPlay loop />
   //                                      </div>
   //                                  )    
   //                              }
   //                          }
   //                          console.log( 'description : ', media.value.image.description )
   //                          return(
   //                              <div title={media.value.image.description}  style={style} className={"brick scrollable image_" + media.value.size.toLowerCase()} key={i}>
   //                                 <img style={{transform:'translateX(0%) translateY(0%)'}} src={Superface.assetUrl(media.value.image.thumb_path)} alt={Superface.field(this._single, 'name')} />
   //                              </div>
   //                          )
   //                  }
   //              })}
   //          </div>
   //      )
   //  }

    renderMedias(){
        if( !this._single.medias.length > 0 ) return
        
        return this._single.medias.map( (media, i) => {
            
            if( media.field.name === 'gallery_l' ){

                if( !Superface.IS_MOBILE ){
                    return (
                        <div style={{ textAlign : ( Math.random() < 0.5 ? 'center' : 'right' )}} className="brick" key={i}>
                            <GalleryLarge i={i} slides={media.value} />
                        </div>
                    )
                }else{
                    return (
                       <div style={{ textAlign : 'center' }} className={"brick image_md"} key={i}>
                            <GallerySmall i={i} slides={media.value} />
                        </div>
                    )
                }

            } else if ( media.field.name === 'gallery_xs' ){
                
                if( media.value === null ) return
                return( 
                   <div style={{ textAlign : ( ( Math.random() < 0.5 || Superface.IS_MOBILE ) ? 'center' : 'right' )}} className={"brick image_md gallery-small"} key={"medias-" + i}>
                        <GallerySmall i={i} slides={media.value} name="single" /> 
                    </div>
                )
                
            } else if ( media.field.name === 'image' ){
                
                if( media.value === null ) return
                if( media.value.image === null ) return
                if( media.value.size === undefined ) 
                  media.value.size = 'md'
                
                if( media.value.image.video ){

                  if( !Superface.IS_MOBILE_OR_TABLET ){
                      return(
                          <div style={{ textAlign : ( ( Math.random() < 0.2 || Superface.IS_MOBILE ) ? 'center' : 'right' )}} className={"brick image_" + media.value.size.toLowerCase()} key={i}>
                              <video muted src={Superface.assetUrl(media.value.image.path)} alt={Superface.field(this._single, 'name')} autoPlay loop />
                          </div>
                      )    
                  }

                }
                
                return(
                   <div style={{ textAlign : ( ( Math.random() < 0.2 || Superface.IS_MOBILE ) ? 'center' : 'right' )}} title={media.value.image.description} className={"brick scrollable image_" + media.value.size.toLowerCase()} key={i}>
                        <img style={{transform:'translateX(0%) translateY(0%)', display:'inline-block'}} src={Superface.assetUrl(media.value.image.thumb_path)} alt={Superface.field(this._single, 'name')} />
                    </div>
                )

            }

        })
        
    }

    // renderMedias(){
    //     if( !this._single.medias.length > 0 ) return
        
    //     let blocks = []
    //     let i = 0
    //     this._single.medias.forEach( media => {
            
    //         if( media.field.name != 'gallery_l' ){

    //             if( blocks[i] === undefined ) blocks[i] = []
    //             blocks[i].push(media)
    //         }else{
    //             i++
    //             blocks[i] = media
    //             i++
    //         }
    //     })

    //     return blocks.map( (bloc, i) => {

    //         if( bloc instanceof Array ){
    //             return this.renderCols(bloc, i)
    //         }else{
    //             if( !Superface.IS_MOBILE ){
    //                 return (
    //                     <div className="brick" key={i}>
    //                         <GalleryLarge i={i} slides={bloc.value} />
    //                     </div>
    //                 )
    //             }else{
    //                 return (
    //                     <div className={"brick image_md"} key={i}>
    //                         <GallerySmall i={i} slides={bloc.value} />
    //                     </div>
    //                 )
    //             }
    //         }
    //     })
        
    // }

    createMarkup(html){
        return { __html : html }
    }
}



// WEBPACK FOOTER //
// ./src/components/Single.js